const Condition = require( './Condition' );
const BattleCalc = require( '../BattleCalc' );
const OptionAttackEvent = require( '../events/OptionAttackEvent' );
const { logError } = require('../logger')

const HasOptionCondition = function( instigator, owner, battleState, potency, charges ) {
	const condition = new Condition( instigator, owner, battleState, potency, charges );
	condition.handle = 'has_option';

	const extant = BattleCalc.getCondition( owner, 'has_option' );
	if( extant ) {
		battleState.expireCondition( extant.uid );
	}

	condition.makeOptionAttack = function() {
    try {
  		if( !battleState || !battleState.allUnits ) {
  			this.expire();
  			return;
  		}

  		var owner = battleState.allUnits[ this.ownerId ];
  		if( owner.dead ) {
  			this.expire();
  			return;
  		}

  		if( battleState.paused ) {
  			return;
  		}

  		var victim = findVictim();
  		if( victim && !victim.dead && victim.inPlay && !isNaN(potency) ) {
  			var optionAttack = new OptionAttackEvent( battleState, owner, potency );
  			optionAttack.execute( victim );

  			if( --this.charges <= 0 ) {
  				this.expire();
  			}
  		}

  		function findVictim() {
  			var enemies = battleState.getEnemiesOfUnit(owner);
  			var potentialTargets = [];				

  			for( var i = 0; i < enemies.length; ++i ) {
  				var enemy = enemies[ i ];
  				if( enemy.inPlay && BattleCalc.boardDistance(owner,enemy) <= 2 ) {
  					potentialTargets.push( enemy );
  				}
  			}
  			
  			if( potentialTargets.length > 0 ) {
  				return potentialTargets[ Math.floor(Math.random()*potentialTargets.length) ];					
  			} else {
  				return null;
  			}			
  		}
    } catch (err) {
      logError(err, {
        module: 'HasOptionCondition',
        func: 'makeOptionAttack',
        instigator,
        owner,
        battleState,
        potency,
        charges
      })
    }
	};

	condition.initInterval( condition.makeOptionAttack, 3000 );
	if( battleState.paused ) {
		condition.intervalTimer.pause();
	}

	return condition;
};
module.exports = HasOptionCondition
